export const LANGUAGE_LABELS: Record<string, string> = {
  en: $localize`language.en`,
  de: $localize`language.de`,
  it: $localize`language.it`,
  fr: $localize`language.fr`,
};
